import getOptUserProfileCookie from './getOptUserProfileCookie';

/**
 * Determines if user allocated to a particular Optimizely experiment (any variation)
 * @param expId - string value of opt experiment ID
 */
var getUserAllocatedToOptExp = function getUserAllocatedToOptExp(expId) {
  var _getOptUserProfileCoo;
  return decodeURIComponent((_getOptUserProfileCoo = getOptUserProfileCookie()) !== null && _getOptUserProfileCoo !== void 0 ? _getOptUserProfileCoo : '').split(',').map(function (idVariantPair) {
    return idVariantPair.split(':')[0];
  }).includes(expId);
};
export default getUserAllocatedToOptExp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/cookies/getUserAllocatedToOptExp.js
// module id = 2641
// module chunks = 11